module.exports = __webpack_public_path__ + "static/media/stores1.10d188a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores/steps/stores1.png
// module id = 1963
// module chunks = 0